import moment from 'moment';

const HiStringSupport = {
  /**
   *
   * @param {*} txt
   * @param {*} maxNumberCharacter
   */
  TextMaximumLength(txt, maxNumberCharacter) {
    if (txt.length < maxNumberCharacter) {
      return txt;
    }
    if (txt.length < (maxNumberCharacter - 3)) {
      return txt;
    }
    const length = maxNumberCharacter - 3;
    return `${txt.substr(0, length)}...`;
  },
};
const HiDateTimeSupport = {
  Duration(value) {
    return moment.duration(value);
  },
  /**
   * Returns a string with the hours or date current required format.
   * @param {string} format
   */
  Format(format) {
    return moment().format(format);
  },
  /**
   * Returns a string with the required format.
   * @param {DateTime, String} dateTime
   * @param {string} format
   */
  FormatDateTime(dateTime, format) {
    const valor = moment(dateTime).format(format);
    return valor;
  },
  /**
   * Given a number of minutes, the total number of hours and minutes
   * @param {number} minutes
   */
  GetHoursAndMinutes(minutes) {
    let totalHours = 0;
    let totalMinutes = 0;
    if (minutes >= 60) {
      totalHours = minutes / 60;
      totalMinutes = (totalHours % 1) * 60;
    } else {
      totalMinutes = minutes;
    }
    if (totalHours > 0) {
      return `${Math.trunc(totalHours)}h ${Math.trunc(totalMinutes)}m`;
    }
    return `${Math.trunc(totalMinutes)}m`;
  },
  /**
   *
   * @param {Date} dateTime
   * @param {number} numberHours
   */
  AddHoursAndMinutes(dateTime, numberHours, numberMinutes) {
    return moment(dateTime).add(numberHours, 'hours').add(numberMinutes, 'minutes').toDate();
  },

  AddSeconds(dateTime, numberSeconds) {
    return moment(dateTime).add(numberSeconds, 'seconds').toDate();
  },

  IsNull(dateTime) {
    if (dateTime === '1900-01-01T00:00:00') {
      return true;
    }
    return false;
  },
};

export { HiDateTimeSupport, HiStringSupport };

export default {

  /** Método  obtenerHorasYMinutos */
  /** Formato Salida: 22:00 */
  obtenerHorasYMinutos(fechaYHora) {
    // console.log("soporteFechaYHora->obtenerHorasYMinutos")
    const date = new Date(fechaYHora);
    // console.log(date.getHours())
    const minutos = (`0${date.getMinutes()}`).slice(-2); // Forzar dos digitos en minutos.
    return `${date.getHours()}:${minutos}`;
    // return date.getHours()+ ":" + date.getMinutes();
  },

  /** Método  ObtenerDiaMesAno */
  /** Formato Salida: 15/08/1990 */
  ObtenerDiaMesAno(fecha) {
    const date = new Date(fecha);
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  },

  /** Método  ObtenerHorasYMinutosDeCadenaHora */
  /** Formato Entrada: 14:00:55 */
  /** Formato Salida: 14:00 */
  ObtenerHorasYMinutosDeCadenaHora(hhmmss) {
    const divisiones = hhmmss.split(':', 3);
    return `${divisiones[0]}:${divisiones[1]}`;
  },

  /** Método  obtenerDDMMAA */
  /**
   Formato Entrada:  obtenerDDMMAA(Date())/
  /** Formato Salida: 15/08/1990*
   */
  obtenerDDMMAA(date) {
    const cDate = new Date(date);
    const dia = cDate.getDate();
    const mes = cDate.getMonth() + 1;
    const ano = cDate.getFullYear();
    return `${dia}/${mes}/${ano}`;
  },

  /** Método  obtenerHHMMSS */
  /**
   Formato Entrada:  obtenerDDMMAA(Date())/
  /** Formato Salida: 20:01:55*
   */
  obtenerHHMMSS(date) {
    const cDate = new Date(date);
    const hh = cDate.getHours();
    const mm = cDate.getMinutes();
    const ss = cDate.getSeconds();
    return `${hh}:${mm}:${ss}`;
  },

  /** Método  obtenerHHMMSS */
  /** Formato Salida:15/08/1990 20:01:55 */
  ObtenerFechaYHoraActual() {
    return `${this.obtenerDDMMAA(new Date())} ${this.obtenerHHMMSS(new Date())}`;
  },

  /** Método  EsFechaNula */
  EsFechaNula(date) {
    return (date === '1900-01-01T00:00:00' || date === '0001-01-01T00:00:00');
  },
};
